// import PCBuild from '../assets/svg/skills/computer.svg'
// import troubleshooting from '../assets/svg/skills/troubleshooting.svg'
// import Networking from '../assets/svg/skills/Networking.svg'
// import CCTVInstallation from '../assets/svg/skills/CCTV.svg'
import CCTV1 from '../assets/proof/cctv1.jpg'
import CCTV2 from '../assets/proof/cctv2.jpg'
import LAPTOP from '../assets/proof/laptop1.jpg'
import SERVICES1 from '../assets/proof/service1.jpg'
import SERVICES2 from '../assets/proof/service2.jpg'
// import CCTV3 from '../assets/proof/cctv3.mp4';
// import CCTV4 from '../assets/proof/cctv4.mp4'

import { PhoneCallbackOutlined } from '@material-ui/icons'

export const skillsImage = (servicesDone) => {
    const serviceID = servicesDone  ;
    switch (serviceID) {
        case 'CCTV1':
            return CCTV1;
         case 'CCTV2':
            return CCTV2;    
        case 'LAPTOP':
            return LAPTOP;
        case 'SERVICES1':
                return SERVICES1;  
        case 'SERVICES2':
             return SERVICES2;
           default:
            break;
    }
}
     // case 'CCTV3':
        //     return CCTV2;
        // case 'CCTV4':
        //      return CCTV4;  

// const ServiceImage = ({ serviceName }) => {
//     const getImageSrc = () => {
//       switch (serviceName.toLowerCase()) {
//         case 'cctv1': return CCTV1;
//         case 'cctv2': return CCTV2;
//         case 'laptop': return LAPTOP;
//         case 'services1': return SERVICES1;
//         case 'services2': return SERVICES2;
//         default: return ''; // Default case to handle unknown service names
//       }
//     };
  
//     const imageSrc = getImageSrc();
  
//     // Inline styles for increasing image size
//     const imageStyles = {
//       width: '200px', // Set your desired width
//       height: '200px', // Set your desired height
//       objectFit: 'cover', // This helps maintain aspect ratio
//     };
  
//     return (
//       <div>
//         {imageSrc && <img src={imageSrc} alt={serviceName} style={imageStyles} />}
//       </div>
//     );
//   };
  
//   // Main component
//   const skillsImage = (serviceName) => {
//     return (
//       <div>
//         <ServiceImage serviceName="CCTV1" />
//         <ServiceImage serviceName="CCTV2" />
//         <ServiceImage serviceName="LAPTOP" />
//         <ServiceImage serviceName="SERVICES1" />
//         <ServiceImage serviceName="SERVICES2" />
//       </div>
//     );
//   };
//   export default skillsImage;
  

// export const skillsImage = (skill) => {
//     const skillID = skill.toLowerCase();
//     switch (skillID) {
//         case 'cc1':
//             return cc1;
//             case 'cc2':
//                 return cc2;    
//         case 'laptop':
//             return laptop;
//         case 'ser1':
//                 return ser1;  
//         case 'ser2':
//              return ser2;
//            default:
//             break;
//     }
// }
